<template>
    <div class="application-module">
        <info />
        <hr>
        <b-form-row>
            <b-col>
                <h5>
                    Industry Certifications To Which The Proposed Cluster, Pathway, or Program of
                    Study Leads
                </h5>
                <arc-table
                    v-model="form.items"
                    striped
                    small
                    bordered
                    :fields="industryCertificationsFields"
                    :editable="!formDisabled"
                    @saveForm="saveForm"
                />
            </b-col>
        </b-form-row>
        <hr>
        <b-form-row>
            <b-col>
                <b-col>
                    <module-actions
                        :is-loading="isSaving"
                        background-color="#006438"
                        @saveForm="saveForm"
                    >
                        >
                    </module-actions>
                </b-col>
            </b-col>
        </b-form-row>
    </div>
</template>

<script>
import info from './Info';
import { mapGetters } from 'vuex';
import { Arc, Log } from '$Shared/@arc/vue-arc';

export default {
    name: 'IndustryCertifications',

    components: {
        info,
    },
    props: {
        formDisabled: { type: Boolean, default: true },
    },

    data() {
        return {
            form: {
                items: [],
            },
            isSaving: false,
        };
    },

    computed: {
        ...mapGetters({
            moduleContent: 'module/moduleContent',
            applicationCertifications: 'ref/application/applicationCertifications',
        }),

        payload() {
            return {
                content: { ...this.form },
            };
        },

        industryCertificationsFields() {
            return [
                {
                    key: 'certification_name',
                    label: 'Certification Name',
                    inputType: 'dropDown',
                    options: this.applicationCertifications,
                },
                {
                    key: 'provider',
                    label: 'Provider',
                    inputType: 'textInput',
                },
                {
                    key: 'cost',
                    label: 'Cost',
                    inputType: 'number',
                },
                {
                    key: 'recognized',
                    label: 'Recognized By Local Employers',
                    inputType: 'dropDown',
                    options: ['NO', 'YES', 'YES w Premium'],
                },

                {
                    key: 'proctored',
                    label: 'Can Be Proctored By Local Staff',
                    inputType: 'dropDown',
                    options: ['NO', 'YES'],
                },
                {
                    key: 'staff',
                    label: 'Have Staff To Proctor',
                    inputType: 'dropDown',
                    options: ['NO', 'YES'],
                },
            ];
        },
    },

    created() {
        this.form = { ...this.form, ...Arc.Objects.clone(this.moduleContent) };
    },

    methods: {
        saveForm() {
            this.isSaving = true;
            this.$store
                .dispatch('module/saveModule', { ...this.payload })
                .then((response) => {
                    this.isSaving = false;
                    Log.debug(response, `COMPONENT:${this.name} -> Save module response:`);
                })
                .catch((arcAlert) => {
                    this.isSaving = false;
                });
        },
    },
};
</script>

<style scoped>
h5 {
    font-size: 20px;
    text-align: center;
    font-weight: bold;
}
</style>
